import type { SignOffField } from "../../shared/api-types/training";

import { useAuthorization } from "../../components/Authorization";
import { COMPUTED_ROLES } from "../../constants";

import { SIGN_OFF_FIELD_ROLE } from "./signOffRoles";

/**
 * Whether the current user may correct this sign-off's date.
 *
 * A hook rather than `WithAnyRole` because callers need the answer as a value, not just to
 * show or hide the button: a screen that renders "Attendance:" alongside the pencil has to
 * drop the label too, or an ineligible user is left staring at a label with nothing under it.
 */
export const useCanEditSignOffDate = (field: SignOffField): boolean => {
  const { hasAnyRole } = useAuthorization();
  return hasAnyRole([COMPUTED_ROLES.SUPER_ADMIN, SIGN_OFF_FIELD_ROLE[field]]);
};

export default useCanEditSignOffDate;
